import React, { useState, useEffect } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { Chip, TextField, Typography } from '@material-ui/core';

import { useDebounce } from '../../../../../../hooks/useDebounce';
import { producaov2 } from '../../../../../../services/apis';

const normalizeUser = (users = []) => {
  return users?.map(user => {
    return {
      id: user?.id,
      name: user?.nome,
      email: user?.email,
      cpf: user?.cpf,
      celular: user?.celular || '',
      address: {
        cep: user?.cep || '',
        street: user?.endereco || '',
        district: user?.bairro || '',
        uf: user?.estado || '',
        city: user?.cidade || '',
        num: user?.numero || '',
        complement: user?.complemento || ''
      }
    }
  });
}

export default function UserField({ selectedUser, onChangeUser, autoFocus, error, helperText }) {
  const [users, setUsers] = useState([]);
  // const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search);
  
  useEffect(() => {
    let isMounted = true;

    const getUsers = async () => {
      if(selectedUser) {
        return;
      }

      try {
        const response = await producaov2.get('alunos', {
          params: {
            search: debouncedSearch,
            additional_fields: 'cpf,celular,endereco,cep,numero,bairro,complemento,estado,cidade',
          }
        });

        if(!isMounted) {
          return;
        }

        setUsers(normalizeUser(response.data) || []);

      } catch(error) {
        console.log(error);

        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    }

    getUsers();

    return () => { isMounted = false }
  }, [debouncedSearch, selectedUser]);

  const handleSearchChange = (search) => {
    if(!isLoading) {
      setIsLoading(true);
    }
  
    setSearch(search);
  }

  const handleChangeUser = (user) => {
    onChangeUser(user);
    setSearch('')
  }
  
  return (
    !!selectedUser ? (
      <Chip
        color="primary"
        label={<Typography variant="subtitle1">{`ID ${selectedUser?.id}: ${selectedUser?.name} - ${selectedUser?.email}`}</Typography>}
        onDelete={() => handleChangeUser(null)}
      />
    ) : (
      <Autocomplete
        autoFocus={autoFocus}
        clearOnEscape
        selectOnFocus
        handleHomeEndKeys
        options={users}
        loading={isLoading}
        value={selectedUser}
        inputValue={search}
        noOptionsText="Nenhum aluno encontrado"
        onInputChange={(event, newValue) => handleSearchChange(newValue)}
        onChange={(event, newValue) => handleChangeUser(newValue)}
        getOptionSelected={(option, value) => option?.id === value?.id}
        getOptionLabel={user => user ? `ID ${user?.id}: ${user?.name} - ${user?.email}` : ''}
        InputProps={{
          error,
          helperText
        }}
        renderInput={(params) => (
          <TextField {...params} label="Busque o aluno" />
        )}
      />
    )
  );
}